import { jsxs as m, Fragment as l, jsx as o } from "react/jsx-runtime";
import { useState as p } from "react";
import { IconButton as g } from "@mui/material";
import { makeStyles as c } from "tss-react/mui";
import { useConfigContext as h } from "@lumirental/lumi-web-shared/lib/contexts/Config.context";
import { getPublicCDNLink as C } from "@lumirental/lumi-web-shared/lib/utils/cdnLinks";
import D from "../../../common/Image/Image.js";
import d from "./DropoffChargesInfo.style.js";
import u from "../Dialogs/DropoffCharges/DropoffChargesDialog.js";
const I = c()(d), x = ({ isSearchFunnel: r = !1 }) => {
  const [n, e] = p(!1), { classes: s } = I(), { appEnv: t } = h(), a = r ? "information-white-icon" : "information-blue-icon", f = () => {
    e(!0);
  }, i = () => {
    e(!1);
  };
  return /* @__PURE__ */ m(l, { children: [
    /* @__PURE__ */ o(
      g,
      {
        "aria-label": "info",
        "data-testid": "dropoffChargesInfoIcon",
        sx: { padding: 0, margin: 0, marginLeft: 0.5 },
        className: s.infoIcon,
        children: /* @__PURE__ */ o(
          D,
          {
            alt: "info",
            src: C(`/images/svg/${a}.svg`, t),
            width: 20,
            height: 20,
            onClick: f
          }
        )
      }
    ),
    /* @__PURE__ */ o(
      u,
      {
        isOpen: n,
        onClose: i
      }
    )
  ] });
}, N = x;
export {
  N as default
};
